import React from 'react';
import styled from '@emotion/styled';
import * as breakpoint from '../../../styles/breakpoints.module.scss';
import { parseHTML } from '../../../functions/common';
import { useLocalization } from 'gatsby-theme-i18n';
import CommentList from '../../../components/CommentList';

const HeroMessageSection = () => {

  const { t } = useLocalization();

  return(
  <SectionWrapper>
    <SectionContent>
      <SectionRow>
        <HeroMessage>
          <Headline><span>{t('home.hero.title').replace('%highlight%',t('home.hero.title.highlight'))}</span>{t('home.event_description.title')}</Headline>
          <Board>{parseHTML(t('about.introduction.lead'),true)}</Board>
        </HeroMessage>
        <CommentList isPickup={true} />
      </SectionRow>
    </SectionContent>
  </SectionWrapper>
  )

}

export default HeroMessageSection;


const SectionWrapper = styled.div`
  position:relative;
  z-index:10;
  
`



const SectionContent = styled.div`
  width:100%;
  max-width:calc(1344px + 96px);
  padding:80px 48px 48px;
  margin:0px auto;

  @media only screen and (max-width: ${breakpoint.smMax}){
    margin:0 80px 0;
    padding:28px 0 64px;
    width:auto;
    max-width:none;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin:32px 24px 0px;
    padding:0px;
  }
`

const SectionRow = styled.div`
  display:flex;
  justify-content: space-between;

  @media only screen and (max-width: ${breakpoint.xsMax}){
    display:block;
  }
`

const Headline = styled.h2`
font-size: 48px;
line-height: 56px;
font-weight: 900;
letter-spacing: 0.03em;
color: #2C2C2E;
text-align:center;
margin-bottom:-12px;
position:absolute;
width:calc(100% - 24px);
bottom:calc(100% - 12px);

  span{
    display:block;
    color: #D00F31;
    font-size: 18px;
    line-height: 24px;
    margin-bottom:12px;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    font-size: 28px;
    line-height: 36px;
    width:calc(100% - 16px);
    span{
      font-size: 12px;
      line-height: 16px;
      margin-bottom: 4px;
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    position:relative;
    bottom:auto;
    left:auto;
    width:100%;
    font-size: 20px;
    line-height: 28px;
    margin-bottom:-10px;
    span{
      font-size: 10px;
      line-height: 14px;
      margin-bottom: 0px;
    }
  }
`

const Board = styled.div`
  background: #FCFCFF;

  box-shadow: 0px 6px 4px -4px rgba(0, 0, 0, 0.1), 0px 12px 8px -8px rgba(0, 0, 0, 0.05), 0px 24px 16px -16px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  padding:64px;

  color: #444448;
  font-size: 20px;
  line-height: 32px;
  display:flex;
  justify-content:center;
  flex-direction:column;
  height:100%;

  p{
    margin-bottom: 1em;

    &:last-of-type{
      margin-bottom: 0;
    }
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    padding:32px;
    font-size: 14px;
    line-height: 24px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding:24px;
    font-size: 12px;
    line-height: 20px;
    margin-bottom:32px;
  }
`

const HeroMessage = styled.div`
  width:67.26%;
  padding-right:24px;
  position:relative;

  @media only screen and (max-width: ${breakpoint.smMax}){
    width:65.78%;
    padding-right:16px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    width:100%;
    padding:0;
  }
`
